import { usePhonePortraitContext } from "contexts/phone-portrait-context";
import { useMemo } from "react";
import { Helmet } from "react-helmet";
import getClasses from "utils/getClasses";
import { SPECIALTY_VALUE } from "../MarketPlace";
import styles from "./MarketPlaceTestimonials.module.scss";
import getTestimonialsData from "./get-testimonials-data";
import getTestimonialsStructuredData from "./get-testimonials-structured-data";

interface MarketPlaceTestimonialsProps {
  specialtyValue: SPECIALTY_VALUE;
}

const MarketPlaceTestimonials = ({
  specialtyValue,
}: MarketPlaceTestimonialsProps) => {
  const { isPhonePortrait } = usePhonePortraitContext();

  const testimonialsData = useMemo(
    () => getTestimonialsData(specialtyValue),
    [specialtyValue],
  );

  const structuredData = useMemo(
    () => getTestimonialsStructuredData(testimonialsData),
    [testimonialsData],
  );

  return (
    <>
      <Helmet>
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      </Helmet>
      <div className={styles["wrapper"]}>
        <div
          className={getClasses(
            styles["container"],
            isPhonePortrait && styles["container--mobile"],
          )}
        >
          <div className={styles["title"]}>
            <h2>Testimonials</h2>
            <p>
              Glowing reviews from Orchid clients after visiting Orchid
              Therapists
            </p>
          </div>
          <ul
            className={getClasses(
              styles["item-list"],
              isPhonePortrait && styles["item-list--mobile"],
            )}
          >
            {testimonialsData.map((item) => (
              <li
                key={item.id}
                className={getClasses(
                  styles["item"],
                  isPhonePortrait && styles["item--mobile"],
                )}
              >
                <div>{item.content}</div>
                <div className={styles["item__footer"]}>
                  <span>{item.date}</span>
                  <span>•</span>
                  <span>{item.author}</span>
                </div>
                <div className={styles["quote-sign"]}>“</div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default MarketPlaceTestimonials;
